import React from 'react';
import { Button, List, ListItem, ListItemText, Menu, MenuItem, Theme, Typography } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(({ palette, spacing }: Theme) =>
    createStyles({
        root: {
            padding: spacing(1),
        },
        menu: {
            width: '60%',
            backgroundColor: palette.background.paper,
        },
        languageMenu: {
            display: 'flex',
        },
    }),
);

// Update this array with names of multi-language test pages
const languages = ['English', 'Spanish'];

const AlmeLanguageMenu: React.FC = () => {
    const selectedLanguageIndex = languages.indexOf(languages.find(lang => window.location.pathname.includes(lang)) ?? 'English');
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [selectedIndex, setSelectedIndex] = React.useState(selectedLanguageIndex);

    const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuItemClick = (event: React.MouseEvent<HTMLElement>, index: number) => {
        setSelectedIndex(index);
        setAnchorEl(null);
    };

    const navigate = () => {
        const selectedLanguage = languages[selectedIndex];
        const baseUrl = window.location.href.substr(0, window.location.href.lastIndexOf('/'));
        let navUrl = baseUrl + `/${selectedLanguage}.html`;
        if (selectedLanguage === 'English')
            navUrl = baseUrl;
        window.open(navUrl, '_self');
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className={classes.root}>
            <Typography>Select language and click button to update page</Typography>
            <div className={classes.languageMenu}>
                <div className={classes.menu}>
                    <List component="nav">
                        <ListItem
                            button
                            aria-haspopup="true"
                            aria-controls="alme-languages-menu"
                            onClick={handleClickListItem}
                        >
                            <ListItemText primary={languages[selectedIndex]} />
                        </ListItem>
                    </List>
                    <Menu
                        id="alme-languages-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        {languages.map((option, index) => (
                            <MenuItem
                                key={option}
                                selected={index === selectedIndex}
                                onClick={(event) => handleMenuItemClick(event, index)}
                            >
                                {option}
                            </MenuItem>
                        ))}
                    </Menu>
                </div>
                <div>
                    <Button
                        style={{ marginLeft: '12px', marginTop: '10px' }}
                        variant='contained'
                        color='default'
                        onClick={navigate}>Update</Button>
                </div>
            </div>
        </div>
    );
};

export default AlmeLanguageMenu;
